import React, { useState } from "react";
import { CheckCircleIcon, DocumentDuplicateIcon } from "@heroicons/react/24/outline";
import { truncate } from "./truncate";
import { isAddress } from "viem";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const CopyToClipboard = _ref => {
  let {
    text
  } = _ref;
  const [copied, setCopied] = useState(false);
  const copyText = () => {
    navigator.clipboard.writeText(text || "").then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 3000);
    }).catch(error => {
      console.error("Failed to copy text: ", error);
    });
  };
  return /*#__PURE__*/_jsxs("div", {
    onClick: copyText,
    className: "flex",
    style: {
      cursor: "pointer"
    },
    children: [isAddress(text || "") ? truncate(text) : text, copied ? /*#__PURE__*/_jsx(CheckCircleIcon, {
      "aria-hidden": "true",
      className: "ml-1 w-5 text-blue-500"
    }) : /*#__PURE__*/_jsx(DocumentDuplicateIcon, {
      "aria-hidden": "true",
      className: "ml-1 w-5 text-blue-500"
    })]
  });
};
export default CopyToClipboard;